import React from 'react';
import { Base, Skeleton } from 'lib/cortiUI';
export function TranscriptsLoader() {
    return (React.createElement(Base, { display: "flex", flexDirection: "column", gap: 4 },
        React.createElement(Skeleton, { variant: "rounded", width: 120 }),
        React.createElement(Base, null, Array.from({ length: 10 }, (_, index) => (React.createElement(Base, { display: "flex", gap: 6, key: index },
            React.createElement(Skeleton, { variant: "text", width: 40 }),
            React.createElement(Skeleton, { variant: "text", width: "100%" })))))));
}
